export abstract class TrackingLabel<ValueType = unknown> {
  abstract readonly name: string;
  abstract readonly value: ValueType;

  abstract isTrackable(): boolean;

  get data(): { [key: string]: ValueType } {
    if (!this.isTrackable()) {
      return {};
    }
    return {
      [this.name]: this.value
    };
  }

  get pipeSeparated(): string {
    if (!this.isValueTypeArray()) {
      throw new Error("value is not an array");
    }
    return (this.value as string[]).join("|");
  }

  private isValueTypeArray(): this is ThisType<{ value: Array<unknown> }> {
    return Array.isArray(this.value);
  }
}
